import { createSelector } from 'reselect';

const selectPolicyDetails = (state) => state;

export const policyDetailsSelector = createSelector(selectPolicyDetails, (policyDetails) => policyDetails.toJS());
